module.exports = __webpack_public_path__ + "img/lorixone-dark.42eafc1d.svg";